import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import EditorAlignJustify from '@wix/da-ds/pkg/Icons/24x24/EditorAlignJustify';
import GalleryGridOutline from '@wix/da-ds/pkg/Icons/24x24/GalleryGridOutline';
import { TableLayout } from '../../types/store';

import s from './TableLayoutSelector.scss';

export interface Props {
  tableLayout: TableLayout;
  onTableLayoutSelect: (tableLayout: TableLayout) => void;
}

const TableLayoutSelector: FC<Props> = ({ tableLayout, onTableLayoutSelect }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <TextButton
        className={cn(s['button'], tableLayout === 'list' && s['active'])}
        size="small"
        variant="main"
        icon={EditorAlignJustify}
        onClick={() => onTableLayoutSelect(TableLayout.LIST)}
      >
        {t('studio.tableLayout.list')}
      </TextButton>
      <TextButton
        className={cn(s['button'], tableLayout === 'grid' && s['active'])}
        size="small"
        variant="main"
        icon={GalleryGridOutline}
        onClick={() => onTableLayoutSelect(TableLayout.GRID)}
      >
        {t('studio.tableLayout.grid')}
      </TextButton>
    </div>
  );
};
TableLayoutSelector.displayName = 'TableLayoutSelector';

export default TableLayoutSelector;
